import React from 'react'
import { SOCIAL_POST_QUERY_PARAM } from '../../services/social'

const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.(com|org|net|edu|gov|br|io|co|me|dev|app)[^\s]*)/gi

/** Extrai postId de URLs internas do feed (/dashboard?socialPost=uuid). */
export function parseSocialPostDeepLink(url: string): string | null {
  try {
    const href = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`
    const parsed = new URL(href)
    const pathname = parsed.pathname.replace(/\/+$/, '') || '/'
    if (pathname !== '/dashboard') return null
    const postId = parsed.searchParams.get(SOCIAL_POST_QUERY_PARAM)
    return postId || null
  } catch {
    return null
  }
}

export function buildSocialPostNavigatePath(postId: string): string {
  return `/dashboard?${SOCIAL_POST_QUERY_PARAM}=${postId}`
}

export interface RenderTextWithLinksOptions {
  onInternalNavigate?: (path: string) => void
}

export function renderTextWithLinks(
  text: string,
  options?: RenderTextWithLinksOptions
): React.ReactNode {
  if (!text) return text

  const parts: React.ReactNode[] = []
  let lastIndex = 0
  let match: RegExpExecArray | null
  let keyCounter = 0

  URL_REGEX.lastIndex = 0

  while ((match = URL_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      const textBefore = text.substring(lastIndex, match.index)
      if (textBefore) parts.push(textBefore)
    }

    const url = match[0]
    const socialPostId = parseSocialPostDeepLink(url)

    if (socialPostId && options?.onInternalNavigate) {
      parts.push(
        <button
          key={`link-${keyCounter++}`}
          type="button"
          className="text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300 underline break-all text-left"
          onClick={(e) => {
            e.stopPropagation()
            options.onInternalNavigate!(buildSocialPostNavigatePath(socialPostId))
          }}
        >
          {url}
        </button>
      )
    } else {
      let href = url
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        href = `https://${url}`
      }

      parts.push(
        <a
          key={`link-${keyCounter++}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300 underline break-all"
          onClick={(e) => e.stopPropagation()}
        >
          {url}
        </a>
      )
    }

    lastIndex = match.index + match[0].length
  }

  if (lastIndex < text.length) {
    const remainingText = text.substring(lastIndex)
    if (remainingText) parts.push(remainingText)
  }

  if (parts.length === 0) return text
  if (parts.length === 1 && typeof parts[0] === 'string') return parts[0]
  return <>{parts}</>
}
